import * as Papa from 'papaparse';

import { ProjectFileUploadOptions } from 'src/store/state/projects';
import { formatSeparator } from 'src/utils/csv/formatSeparator';

export const getNonEmptyPreviewRow = (
  contents: string,
  options: ProjectFileUploadOptions
) => {
  const optionsToUse: Papa.ParseConfig = {
    skipEmptyLines: true,
    preview: 25,
    delimiter: formatSeparator(options.separator),
    escapeChar: options.escape,
    header: options.header,
    quoteChar: options.quote,
  };

  const csv = Papa.parse(contents, optionsToUse);
  const dataToUse = csv.data;
  const csvKeys = Object.keys(dataToUse[0]);
  // for each column, look in the first 25 rows for the first non-empty value
  // return key and the value
  // if no non empty value is found, use the key as the value
  const previewRow = dataToUse[0];
  csvKeys.forEach((column) => {
    const value = dataToUse.find((row) => row[column] !== '');
    if (value) {
      previewRow[column] = value[column];
    } else {
      previewRow[column] = column;
    }
  });

  return previewRow;
};
